module.exports = __webpack_public_path__ + "img/logo.d78f8eab.png";